import React, { useCallback, useEffect, useState } from 'react';
import { render, unmountComponentAtNode } from 'react-dom';

import { AlertOverlay, ConfirmAlertBody, ButtonGroup } from './styles';

interface IReactConfirmAlertProps {
  title: string;
  message: string;
  closeOnClickOutside?: boolean;
  closeOnEscape?: boolean;
  onConfirm: () => void;
}

const ReactConfirmAlert: React.FC<IReactConfirmAlertProps> = (props) => {
  const {
    closeOnClickOutside = true,
    closeOnEscape = true,
    title,
    message,
    onConfirm,
  } = props;

  const [overlay, setOverlay] = useState<any>(null);

  const close = (): void => {
    removeElementReconfirm();
  };

  const handleClickOverlay = (e: any): void => {
    const isClickOutside = e.target === overlay;

    if (closeOnClickOutside && isClickOutside) {
      close();
    }
  };

  const keyboardClose = useCallback(
    (event: any) => {
      const isKeyCodeEscape = event.keyCode === 27;

      if (closeOnEscape && isKeyCodeEscape) {
        close();
      }
    },
    [closeOnEscape]
  );

  useEffect(() => {
    const root = document.getElementById('root');
    root?.addEventListener('keydown', keyboardClose, false);
    return (): void => {
      root?.removeEventListener('keydown', keyboardClose, false);
    };
  }, [keyboardClose]);

  const confirm = (): void => {
    onConfirm();
    close();
  };

  return (
    <AlertOverlay
      ref={(dom: HTMLDivElement): void => setOverlay(dom)}
      onClick={handleClickOverlay}
    >
      <ConfirmAlertBody>
        {title && <h2>{title}</h2>}
        {message}
        <ButtonGroup>
          <button onClick={confirm}>Confirm</button>
          <button onClick={close}>Cancel</button>
        </ButtonGroup>
      </ConfirmAlertBody>
    </AlertOverlay>
  );
};

function removeElementReconfirm(): void {
  const target = document.getElementById('react-confirm-alert');
  if (target) {
    unmountComponentAtNode(target);
    target?.parentNode?.removeChild(target);
  }
}

export function confirmAlert(properties: IReactConfirmAlertProps): void {
  let divTarget = document.getElementById('react-confirm-alert');
  if (divTarget) {
    render(<ReactConfirmAlert {...properties} />, divTarget);
  } else {
    divTarget = document.createElement('div');
    divTarget.id = 'react-confirm-alert';
    document.body.appendChild(divTarget);
    render(<ReactConfirmAlert {...properties} />, divTarget);
  }
}
